import { render, staticRenderFns } from "./traineesApproval.vue?vue&type=template&id=316970d4&scoped=true"
import script from "./traineesApproval.vue?vue&type=script&lang=js"
export * from "./traineesApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316970d4",
  null
  
)

export default component.exports